import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
export function sortPagesByOrder(pages, sortFieldName) {
  return _toConsumableArray(pages).sort(function (pageA, pageB) {
    // If 'order' is not set, default to the length of the pages
    var orderA = _get(pageA, sortFieldName, pages.length);
    var orderB = _get(pageB, sortFieldName, pages.length);
    orderA = _isNumber(orderA) && orderA >= 0 ? orderA : pages.length;
    orderB = _isNumber(orderB) && orderB >= 0 ? orderB : pages.length;
    return orderA - orderB;
  });
}
export function getChildPagesForSlug(slug, pages) {
  var childPages = pages.filter(function (_ref) {
    var currentSlug = _ref.slug;
    return currentSlug.startsWith(slug) && currentSlug !== slug;
  });
  return sortPagesByOrder(childPages, 'navigationOrder');
}
export function groupPagesBySlug() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var groupedPages = [];
  pages.forEach(function (page) {
    var slug = page.slug;
    var childPages = getChildPagesForSlug(slug, pages);
    if (!_isEmpty(childPages)) {
      groupedPages = [].concat(_toConsumableArray(groupedPages), [_objectSpread(_objectSpread({}, page), {}, {
        childPages: childPages
      })]);
    }
  });
  var sortedGroupedPages = sortPagesByOrder(groupedPages, 'navigationGroupOrder');
  return sortedGroupedPages.reduce(function (acc, page) {
    var _page$navigationGroup = page.navigationGroup,
      navigationGroup = _page$navigationGroup === void 0 ? '' : _page$navigationGroup;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, navigationGroup, [].concat(_toConsumableArray(acc[navigationGroup] || []), [page])));
  }, {});
}